import {ActionReducerMap} from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import * as fromRouterReducers from './router.reducer';
import * as fromLoginReducers from './login.reducer';
import * as appSettingsReducer from './app-settings.reducer';
import * as cartReducer from './cart.reducer';
import * as filterReducer from './filter.reducer';
import {AppSetting, Cart, ItemsReq} from '@app/core/models';

export * from './router.reducer';

// Feature by core module
export interface AppState {
  login: fromLoginReducers.LoginState;
  routerReducer: fromRouter.RouterReducerState<fromRouterReducers.RouterStateUrl>;
  appSettingsReducer: AppSetting;
  cartReducer: Cart;
  filterReducer: ItemsReq;
}

export const CORE_INITIAL_STATE: AppState = {
  filterReducer: {
    branchId: 0,
    categoryId: 0,
    isMostLiked: false,
    isMostSelling: false,
    isNew: false,
    isRecommended: false,
    isSortedByPriceHighToLow: false,
    isSortedByPriceLowToHigh: false,
    maxPrice: 0,
    minPrice: 0,
    page: 0,
    searchKeyword: '',
    size: 0,
  },
  login: {
    authorization: { type: 0, status: false },
    loginProcess: '',
    loginError: null,
  },
  routerReducer: {
    state: {
      url: '',
      params: {},
      queryParams: {},
    },
    navigationId: 0,
  },
  appSettingsReducer: {
    TargetAppVersion: '',
    UpdateIsRequired: false,
    CartCount: 0,
    NotificationCount: 0,
    HomeSettings: {
      HomeCategories: [],
      ShowBottomBanner: false,
      ShowMostSelling: false,
      ShowNewProducts: false,
      ShowTopBanner: false,
    },
    StartupTutorials: [],
  },
  cartReducer: {
    CartId: 0,
    UserId: 0,
    CouponId: 0,
    CouponApplied: false,
    CouponCode: '',
    SubTotal: 0,
    SubTotalTitle: '',
    Discount: 0,
    DiscountTitle: '',
    TotalAmount: 12,
    TotalAmountTitle: '',
    DeliveryCharge: 0,
    DeliveryChargeTitle: '',
    PaymentMethod: 0,
    Notes: '',
    AddressRequired: false,
    UserCartBranches: [],
    UsersCartsAddresses: '',
    CartPaymentMethodList: [],
    BranchId: 0,
  },
};

export const reducers: ActionReducerMap<AppState> = {
  login: fromLoginReducers.loginReducer,
  routerReducer: fromRouter.routerReducer,
  appSettingsReducer: appSettingsReducer.appSettingsReducer,
  cartReducer: cartReducer.cartReducer,
  filterReducer: filterReducer.filterReducer,
};
